<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import { Radio } from 'lucide-svelte';
  import Button from '../atoms/Button.svelte';
  import IconBadge from '../atoms/IconBadge.svelte';
  import FormField from '../molecules/FormField.svelte';

  interface Props {
    userName: string;
    roomName: string;
    error?: string;
    onJoin?: () => void;
    onUserNameChange?: (value: string) => void;
    onRoomNameChange?: (value: string) => void;
  }

  let {
    userName = $bindable(''),
    roomName = $bindable(''),
    error,
    onJoin,
    onUserNameChange,
    onRoomNameChange,
  }: Props = $props();
</script>

<div class="w-full max-w-md relative z-10">
  <div class="text-center mb-8">
    <div class="inline-flex items-center gap-3 mb-4">
      <IconBadge tone="indigo" size="lg">
        <Radio class="w-7 h-7 text-white" />
      </IconBadge>
    </div>
    <h1 class="text-4xl font-bold text-white tracking-tight">ForFridgeBeta</h1>
    <p class="text-slate-400 text-sm mt-2">Голосовые комнаты для своих</p>
  </div>

  <div class="backdrop-blur-xl bg-white/5 border border-white/10 rounded-2xl p-6 shadow-2xl">
    <div class="space-y-4">
      <FormField
        label="Ваше имя"
        bind:value={userName}
        placeholder="например, Алексей"
        maxlength={20}
        onInput={onUserNameChange}
        onEnter={onJoin}
      />
      <FormField
        label="Название комнаты"
        bind:value={roomName}
        placeholder="например, family-sunday"
        maxlength={30}
        helper="Поделитесь этим именем с участниками"
        onInput={onRoomNameChange}
        onEnter={onJoin}
      />
      {#if error}
        <div class="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">
          {error}
        </div>
      {/if}
      <Button variant="primary" size="lg" fullWidth onclick={() => onJoin?.()}>
        Войти в комнату
      </Button>
    </div>
  </div>

  <p class="text-center text-xs text-slate-500 mt-6">Браузер запросит доступ к микрофону</p>
</div>
